export const PermissionEnum = [
  'accounts:read',
  'affiliates:read',
  'affiliates:write',
  'authorizations:read',
  'beneficiaries:read',
  'cards:read',
  'cards:unmaskPan',
  'cards:write',
  'clearings:read',
  'commercialProduct',
  'commercialProduct:read',
  'commercialProduct:update',
  'distributors:all',
  'distributors:read',
  'distributors:write',
  'folder:close',
  'internal',
  'orders:read',
  'outstanding:emit',
  'param:control',
  'param:difference',
  'technicalProduct',
  'transaction:match',
  'ttnr:access',
  'users:read',
  'users:role',
  'users:write',
  'product',
  'product:read',
  'product:create',
]
